<script lang="ts">
    import Portrait from "$lib/components/Portrait.svelte";
    import TierBadge from "$lib/components/TierBadge.svelte";
    import { formatPercent, getTextColorClass, getStatRange } from "$lib/utils/formatting";
    import { getRoleIcon } from "$lib/utils/images";
    import type { HeroStats } from "$lib/types";

    let {
        tanks,
        damage,
        supports,
        heroLinkSuffix = "",
        count = 5,
    }: {
        tanks: HeroStats[];
        damage: HeroStats[];
        supports: HeroStats[];
        heroLinkSuffix?: string;
        count?: number;
    } = $props();

    const allHeroes = $derived([...tanks, ...damage, ...supports]);
    const [winRateMin, winRateMax] = $derived(getStatRange(allHeroes, "winRate"));
</script>

<div class="grid grid-cols-1 gap-6 md:grid-cols-3">
    {#each [{ label: "Tank", role: "tank", list: tanks }, { label: "Damage", role: "damage", list: damage }, { label: "Support", role: "support", list: supports }] as section (section.role)}
        <div class="card bg-base-300 shadow-lg">
            <div class="card-body p-5">
                <h3 class="card-title text-xl text-base-content flex items-center gap-2">
                    <img
                        src={getRoleIcon(section.role)}
                        alt={section.role}
                        width="22"
                        height="22"
                        class="brightness-0 invert"
                    />
                    {section.label}
                </h3>
                <div class="mt-1 flex flex-col gap-1.5">
                    {#each section.list.slice(0, count) as hero, i (hero.slug)}
                        <a
                            href="/heroes/{hero.slug}{heroLinkSuffix}"
                            class="flex items-center gap-3 rounded-lg bg-base-200 px-3 py-2 transition-colors hover:bg-base-100"
                        >
                            <span class="w-4 text-center text-sm font-bold text-base-content/50">{i + 1}</span>
                            <Portrait slug={hero.slug} alt={hero.name} size={36} />
                            <span class="flex-1 font-medium">{hero.name}</span>
                            <TierBadge tier={hero.tier} size="sm" />
                            <span
                                class="text-sm font-semibold tabular-nums {getTextColorClass(
                                    hero.winRate,
                                    winRateMin,
                                    winRateMax,
                                )}"
                            >
                                {formatPercent(hero.winRate)}
                            </span>
                        </a>
                    {/each}
                </div>
            </div>
        </div>
    {/each}
</div>
